import React, { PureComponent } from 'react';
import './CheckoutHeader.scss';

export class CheckoutHeader extends PureComponent {
    render(): JSX.Element {
        return (
            <div className='checkout-header'>
                <div className='checkout-header__link'>
                    <a href='/'>
                        <h1 className='checkout-header__logo'>Sofology</h1>
                    </a>
                </div>
                <div className='checkout-header__phone'>
                    <span>
                        <i className='sa sa-contact checkout-header__phone-icon'></i>
                        <a href='tel:+44800-140-40-40'>Call us free </a>
                    </span>
                    <span className='checkout-header__phone-number'>
                        on 0800 140 4040
                    </span>
                </div>
            </div>
        );
    }
}